import styled from 'styled-components'

export const ContainerAcoes = styled.div`
  display: flex;
  justify-content: flex-end;
`
